import { Token } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.css']
})
export class LoginFormComponent implements OnInit {

  mostrarSenha: boolean = false;

  constructor(
    public auth: AuthService
  ) { }

  ngOnInit(): void {
    this.auth.aguardeDialog = false;
  }

  login(usuario: string, senha: string) {
    this.auth.login(usuario, senha);
  }
  
}
